module.exports = __webpack_public_path__ + "img/ir.23e0f96c.svg";